<script>
  import {mapState} from 'vuex'
  import _base from '../../_default/components/_base.vue'
  import VueEasyPieChart from 'vue-easy-pie-chart'
  import 'vue-easy-pie-chart/dist/vue-easy-pie-chart.css'
  import UserStats from './UserStats'
  import DashAnaliseCadastro from './AnaliseCadastro'
  import DashProximosLeiloes from './DashLeiloes'

  export default{
    extends: _base,
    data () {
      return {}
    },
    mounted () {
      this._menuFolded(true)
      window.setTimeout(() => {
        this._menuFolded(false)
      }, 4000)
    },
    computed: {
      ...mapState({
        showHeader: state => state.app.showHeader,
        showMenu: state => state.app.showMenu
      })
    },
    methods: {},
    components: {
      DashProximosLeiloes,
      DashAnaliseCadastro,
      UserStats,
      VueEasyPieChart
    }
  }
</script>

<template>
  <div class="app-content">

    <div class="app-content-body dashboard">

      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">
            <div class="bg-light lter b-b-xs wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12"><h1 class="font-thin h3">
                  Dashboard</h1>
                  <small class="text-muted">
                    APL Leilões
                  </small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">

                  </div>
                </div>
              </div>
            </div>

            <div class="wrapper-md">
              Seja bem vindo à intranet. Estamos trabalhando para levar o máximo de informação aos colaboradores. <!--, dúvidas e/ou sugestões envie um e-mail para <a class="text-info" href="mailto:suporte@rogeriomenezes.com.br">suporte@rogeriomenezes.com.br</a>-->
              <br><br>
              Nosso dashboard está temporariamente desativado.
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>




// WEBPACK FOOTER //
// Main.vue?c986b162